import { ReactNode } from 'react';
import { Grid } from '@mui/material';
import {
    ConfirmationBox,
    ConfirmationStatus,
} from '@/components/forms/wrappers/WithConfirmationStatus/ConfirmationBox/ConfirmationBox';

interface WithConfirmationStatusProps {
    children: ReactNode;
    confirmed: boolean;
    pendingPhrase?: string;
}

export const WithConfirmationStatus = ({
    children,
    confirmed,
    pendingPhrase,
}: WithConfirmationStatusProps) => (
    <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>{children}</Grid>
        <Grid size={{ xs: 12, md: 6 }}>
            {confirmed !== undefined && (
                <ConfirmationBox
                    status={confirmed ? ConfirmationStatus.Confirmed : ConfirmationStatus.Pending}
                    pendingPhrase={pendingPhrase}
                />
            )}
        </Grid>
    </Grid>
);
